import React, { Component } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheckCircle,
  faDownload,
  faVideo,
  faCalendarAlt,
  faPaperPlane,
  faAngleDown,
  faAngleUp,
 
} from "@fortawesome/free-solid-svg-icons";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { Card, Row, Col, CardBody, CardHeader, Label } from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MaterialComponent from "./LearnerAssesment/MaterialComponent";

import { Link } from "react-router-dom";
// import Modal from "react-modal";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TextField from "@material-ui/core/TextField";

import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../css/course-catelog.css";

import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";

import Tooltip from "@material-ui/core/Tooltip";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import EventIcon from "@material-ui/icons/Event";
class Announcement extends Component {
  constructor(props) {
    super(props);
    const noticeslist = [];
    const courseDuration = [];

    const markseen = "";
    const myquizlist = [];
    const eventlist = [];
    const viewmoreid = "";
    const markid = "";

    const title = "";
    const description = "";
    const date = "";
    const fromtime = "";
    const totime = "";
    const courseWebinarlist = [];

    this.state = {
      title,
      description,
      date,
      fromtime,
      totime,
      ismail: false,
      courseWebinarlist,
      noticeslist,
      courseDuration,
      modalIsOpen: false,
      ismark: false,
      markseen,
      myquizlist,
      eventlist,
      viewmoreComponent: false,
      viewmoreid,
      markid,
      eventmodalIsOpen: false,
      loading: false,
      myfile: "",
      myfileextension: "",
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.viewmore = this.viewmore.bind(this);
    this.viewless = this.viewless.bind(this);

    this.openEventModal = this.openEventModal.bind(this);
    this.closeEventModal = this.closeEventModal.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  componentDidMount() {
    this.getCoursedetails();
  }

  async getCoursedetails() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    axios
      .post("Announcement/showNotice", formData)
      .then((res) => {
        if (res.data.status === "200") {
          // console.log(res.data);
          this.setState({
            noticeslist: res.data.noticeslist,
            courseOwner: res.data.courseowner,
            myquizlist: res.data.myquizlist,
            eventlist: res.data.eventlist,
            courseWebinarlist: res.data.courseWebinarlist,
          });

          // console.log("eventlist  ==" + this.state.eventlist);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  handleClick(e, id) {
    e.preventDefault();
    this.getmarkasread(id);
  }

  async getmarkasread(id) {
    this.setState({ loading: true });
    // console.log(" ingettransactiondetails ");
    // console.log(" caid " + id);

    //  var varvalue = window.location.pathname.replace("/transaction/", "");
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("caid", id);
    axios
      .post("Announcement/viewNotice", formData)
      .then((res) => {
        if (res.data.status === "200") {
          // console.log(" in res.view  === " + res.data);

          this.setState({
            ismark: true,
            markid: id,
            noticeslist: res.data.noticeslist,
            loading: false,
          });
          // window.location.reload(true);
          // console.log(" in markid === " + this.state.markid);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  viewmore(e, id) {
    e.preventDefault();

    this.setState({
      viewmoreComponent: true,
      viewmoreid: id,
    });
  }

  viewless(e, id) {
    e.preventDefault();
    // alert(id);
    this.setState({
      viewmoreComponent: false,
    });
  }

  openEventModal() {
    this.setState({ eventmodalIsOpen: true });
  }

  closeEventModal() {
    this.setState({ eventmodalIsOpen: false });
  }
  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.saveEventdetails();
  }
  openmymodel(myfile,noticeextension)
  {
    this.state.myfile=myfile
    this.state.myfileextension=noticeextension
    this.openModal()

  }
  async saveEventdetails() {
    this.setState({ loading: true });
    if (
      this.state.title === "" ||
      this.state.decription === "" ||
      this.state.date === "" ||
      this.state.fromtime === "" ||
      this.state.totime === ""
    ) {
      toast.error("All Fields are mandatory");
      await this.sleep(3000);
      this.setState({ loading: false });
      return;
    } else {
      // console.log("ismail  ]=== " + this.state.ismail);
      var formData = new FormData();
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("eventdate", this.state.date);
      formData.append("eventtitle", this.state.title);
      formData.append("eventdesc", this.state.decription);
      formData.append("eventfrom", this.state.fromtime);
      formData.append("eventto", this.state.totime);
      formData.append("ismail", this.state.ismail);

      await axios
        .post("Announcement/saveEventDetails", formData)

        .then((res) => {
          if (res.data.status === "200") {
            toast.success("Event added Successfully ");
            this.setState({
              eventmodalIsOpen: false,
              loading: false,
              myquizlist: res.data.myquizlist,
              eventlist: res.data.eventlist,
            });
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  }

  render() {
    return (
      <div className="bg-color">
        <section>
          <Row>
            <Col sm={12}>
              <Row>
                <Col xs={12} md={8} sm={8}>
                  {this.state.noticeslist.length === 0 ? (
                    <center>
                      <br /> <br />
                      <img
                        dir="images"
                        src="/assets/images/icons/no-announcement.svg"
                        alt="no-announcement"
                        width="300"
                        height="150"
                        className="img-thumbnail"
                      />
                      <br /><br />
                      <h6>"Hooray! No Announcements!"</h6>
                    </center>
                  ) : (
                    " "
                  )}
                  <section class="ann-section">
                    {this.state.noticeslist.map((item) => (
                      <>
                        <div class="announcementbox">
                          <Row>
                            <Col sm={2}>
                              <div class="pull-left">
                                <img
                                  src={item.imagepath}
                                  alt=""
                                  width="80"
                                  height="50"
                                  class="ann-img"
                                />
                              </div>
                            </Col>
                            <Col sm={7}>
                              <div>
                                <h6>{item.instructorname}</h6>

                                <p>
                                  <FontAwesomeIcon
                                    icon={faCalendarAlt}
                                    color="blue"
                                  />{" "}
                                  {item.noticeDate}
                                </p>
                              </div>
                              {item.downloadnotice !== null ? (
                            <Row>
                              <Col sm={11}>
                                <label className="pt-2">
                                  Downloadable Material for this Announcement<Link onClick={(e) =>this.openmymodel(item.downloadnotice,item.noticeextension)}>
                                  {"   "}<CloudDownloadIcon />
                                </Link>
                                </label>
                              </Col>
                              
                            </Row>
                          ) : (
                            ""
                          )}
                            </Col>
                            <Col sm={3}>
                              {item.isseen === "seen" ||
                              (this.state.ismark === true &&
                                this.state.markid === item.noticeid) ? (
                                <>
                                  <center>
                                    <h4 style={{ color: "navy" }}>
                                      <FontAwesomeIcon icon={faCheckCircle} />
                                    </h4>
                                  </center>
                                </>
                              ) : (
                                <>
                                  <center>
                                    <>
                                      <div className="root">
                                        <div className="wrapper">
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            //  className="buttonSuccess"
                                            disabled={this.state.loading}
                                            onClick={(e) =>
                                              this.handleClick(e, item.noticeid)
                                            }
                                          >
                                            Mark as Read
                                          </Button>

                                          {this.state.loading === true ? (
                                            <CircularProgress
                                              size={24}
                                              color="green"
                                              className="buttonProgress1"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  </center>
                                </>
                              )}
                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <Col sm={12}>
                              <p> {item.notice} </p>
                            </Col>
                          </Row>
                          <hr />

                         
                        </div>
                        <br />
                      </>
                    ))}

                    <Modal
                      isOpen={this.state.modalIsOpen}
                      onRequestClose={this.closeModal}
                      size="lg"
                      style={{
                        top: "0%",
                        left: "0%",
                        right: "0%",
                        bottom: "0%",
                        maxWidth: "1600px",
                        width: "60%",
                        height: "60%",
                      }}
                    >
                      <ModalHeader
                        toggle={this.closeModal}
                      ></ModalHeader>
                      <ModalBody>
                        <div>
                          <MaterialComponent
                            contentType="contenttype"
                            contentId="0"
                            materialid="0"                          
                            materialtype={this.state.myfileextension}
                             materialpath={this.state.myfile}
                          />
                        </div>
                      </ModalBody>
                      <ModalFooter></ModalFooter>
                    </Modal>
                  </section>
                </Col>

                <Col xs={12} md={4} sm={4}>
                  <Card>
                    <CardHeader>
                      <Row>
                        <Col sm={9}>
                          <b>Upcoming Events</b>
                        </Col>
                        <Col sm={2}>
                          <Link onClick={this.openEventModal}>
                            <div>
                              <Tooltip
                                title="Add Event "
                                aria-label="add Event"
                              >
                                <Fab
                                  color="primary"
                                  style={{ height: "5px", width: "35px" }}
                                >
                                  <AddIcon />
                                </Fab>
                              </Tooltip>
                            </div>
                          </Link>

                          <Modal
                            isOpen={this.state.eventmodalIsOpen}
                            onRequestClose={this.closeEventModal}
                            size="md"
                          >
                            <ModalHeader
                              className="header-modalc"
                              toggle={this.closeEventModal}
                            >
                              Add Event
                            </ModalHeader>
                            <ModalBody>
                              <div>
                                <Row>
                                  <Col lg={12}>
                                    <form>
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <TextField
                                            label="Title"
                                            type="text"
                                            id="title"
                                            name="title"
                                            style={{ width: "100%" }}
                                            onChange={(e) =>
                                              this.setState({
                                                title: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <TextField
                                            label="Description"
                                            style={{ width: "100%" }}
                                            type="text"
                                            id="decription"
                                            name="decription"
                                            multiline
                                            rowsMax={2}
                                            onChange={(e) =>
                                              this.setState({
                                                decription: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>{" "}
                                      <br />
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <TextField
                                            id="date"
                                            type="date"
                                            name="date"
                                            label="Date"
                                            variant="standard"
                                            style={{ width: "50%" }}
                                            defaultValue={new Date()}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            onChange={(e) =>
                                              this.setState({
                                                date: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>
                                      <br />
                                      <div class="row">
                                        <div class="col-sm-6">
                                          {/* <label>
                                            <b> From :</b>
                                          </label> */}
                                          <TextField
                                            id="fromtime"
                                            type="time"
                                            name="fromtime"
                                            label="From"
                                            variant="standard"
                                            style={{ width: "100%" }}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            onChange={(e) =>
                                              this.setState({
                                                fromtime: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                        <div class="col-sm-6">
                                          {/* <label>
                                            <b> To :</b>
                                          </label> */}

                                          <TextField
                                            id="totime"
                                            type="time"
                                            name="totime"
                                            label="To"
                                            variant="standard"
                                            style={{ width: "100%" }}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            onChange={(e) =>
                                              this.setState({
                                                totime: e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      </div>
                                      <br />
                                      <div class="row">
                                        <div
                                          class="col-sm-12"
                                          style={{ display: "flex" }}
                                        >
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                name="ismail"
                                                checked={this.state.ismail}
                                                onChange={(e) =>
                                                  this.setState({
                                                    ismail:
                                                      e.target.type ===
                                                      "checkbox"
                                                        ? e.target.checked
                                                        : e.target.value,
                                                  })
                                                }
                                                color="primary"
                                              />
                                            }
                                            label="Is Email Notification"
                                          />
                                        </div>
                                      </div>
                                      <br />
                                      <div className="row">
                                        <div className="col-lg-12 text-center">
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            //  className="buttonSuccess"
                                            disabled={this.state.loading}
                                            onClick={this.handleSubmit}
                                          >
                                            Save
                                          </Button>

                                          {this.state.loading === true ? (
                                            <CircularProgress
                                              size={24}
                                              color="green"
                                              className="buttonProgress1"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </form>
                                  </Col>
                                </Row>
                              </div>
                            </ModalBody>
                          </Modal>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody className="up-card">
                      <div id="style-6" class="desc scrollbar-ann">
                        <span class="force-overflow-ann">
                          {this.state.courseWebinarlist.map((itemname) => (
                            <>
                              {itemname.wlink !== null ||
                              itemname.wlink !== "" ? (
                                <>
                                  <div class="coursecat1">
                                    <Card
                                      style={{
                                        width: "100%",
                                        //border: "1px solid #232",
                                        padding: "5px",
                                        height: "auto",
                                        boxShadow: "rgb(162, 163, 159)",
                                      }}
                                    >
                                      <CardBody>
                                        <Row>
                                          <Col sm={12}>
                                            {/* <Link to={itemname.wlink}>
                                              {" "}
                                              {itemname.title}
                                            </Link> */}
                                            <Label>
                                              <a href={itemname.wlink} target = "_blank" rel="">
                                                {" "}
                                                <FontAwesomeIcon
                                                  icon={faVideo}
                                                  color="red"
                                                />
                                                &nbsp;&nbsp;
                                                {itemname.title}
                                              </a>
                                            </Label>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm={6}>
                                            <p>
                                              {" "}
                                              <FontAwesomeIcon
                                                icon={faCalendarAlt}
                                                color="blue"
                                              />
                                              &nbsp;
                                              {itemname.webinardate}
                                            </p>
                                          </Col>
                                          <Col sm={6}>
                                            {" "}
                                            <FontAwesomeIcon
                                              icon={faClock}
                                              color="orange"
                                            />
                                            &nbsp;
                                            {itemname.time}
                                          </Col>
                                        </Row>
                                        <br />

                                        {this.state.viewmoreComponent ===
                                          true &&
                                        this.state.viewmoreid ===
                                          itemname.eventid ? (
                                          <>
                                            <Row>
                                              <Col sm={12}>
                                                <Link
                                                  onClick={(e) =>
                                                    this.viewless(
                                                      e,
                                                      itemname.eventid
                                                    )
                                                  }
                                                >
                                                  <div
                                                    style={{
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <Tooltip
                                                      title="View Less "
                                                      aria-label="View Less"
                                                    >
                                                      <Fab
                                                        color="inherit"
                                                        size="small"
                                                      >
                                                        <FontAwesomeIcon
                                                          size="1x"
                                                          icon={faAngleUp}
                                                        />
                                                      </Fab>
                                                    </Tooltip>
                                                  </div>
                                                </Link>
                                                <p>
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        itemname.description,
                                                    }}
                                                  />
                                                </p>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : (
                                          <Row>
                                            <Col sm={12}>
                                              <Link
                                                onClick={(e) =>
                                                  this.viewmore(
                                                    e,
                                                    itemname.eventid
                                                  )
                                                }
                                              >
                                                <div
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <Tooltip
                                                    title="View more "
                                                    aria-label="View more"
                                                  >
                                                    <Fab
                                                      color="primary"
                                                      size="small"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faAngleDown}
                                                        size="1x"
                                                      />
                                                    </Fab>
                                                  </Tooltip>
                                                </div>
                                              </Link>
                                            </Col>
                                          </Row>
                                        )}
                                      </CardBody>
                                    </Card>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          ))}

                          {this.state.eventlist.map((itemname) => (
                            <>
                              {itemname.wlink !== null ||
                              itemname.wlink !== "" ? (
                                <>
                                  <div class="coursecat1">
                                    <Card
                                      style={{
                                        width: "100%",
                                        //border: "1px solid #232",
                                        padding: "5px",
                                        height: "auto",
                                        boxShadow: "rgb(162, 163, 159)",
                                      }}
                                    >
                                      <CardBody>
                                        <Row>
                                          <Col sm={12}>
                                            {/* <Link to={itemname.wlink}>
                                              {" "}
                                              {itemname.title}
                                            </Link> */}
                                            <Label>
                                              <EventIcon color="secondary" />
                                              &nbsp;&nbsp;
                                              {itemname.title}
                                            </Label>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm={6}>
                                            <p>
                                              {" "}
                                              <FontAwesomeIcon
                                                icon={faCalendarAlt}
                                                color="blue"
                                              />
                                              &nbsp;
                                              {itemname.ondate}
                                            </p>
                                          </Col>
                                          <Col sm={6}>
                                            {" "}
                                            <FontAwesomeIcon
                                              icon={faClock}
                                              color="orange"
                                            />
                                            &nbsp;
                                            {itemname.ontime}
                                          </Col>
                                        </Row>
                                        <br />

                                        {this.state.viewmoreComponent ===
                                          true &&
                                        this.state.viewmoreid ===
                                          itemname.eventid ? (
                                          <>
                                            <Row>
                                              <Col sm={12}>
                                                <Link
                                                  onClick={(e) =>
                                                    this.viewless(
                                                      e,
                                                      itemname.eventid
                                                    )
                                                  }
                                                >
                                                  <div
                                                    style={{
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <Tooltip
                                                      title="View Less "
                                                      aria-label="View Less"
                                                    >
                                                      <Fab
                                                        color="inherit"
                                                        size="small"
                                                      >
                                                        <FontAwesomeIcon
                                                          size="1x"
                                                          icon={faAngleUp}
                                                        />
                                                      </Fab>
                                                    </Tooltip>
                                                  </div>
                                                </Link>

                                                <p>
                                                  {" "}
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        itemname.description,
                                                    }}
                                                  />
                                                </p>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : (
                                          <Row>
                                            <Col sm={12}>
                                              <Link
                                                onClick={(e) =>
                                                  this.viewmore(
                                                    e,
                                                    itemname.eventid
                                                  )
                                                }
                                              >
                                                

                                                <div
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <Tooltip
                                                    title="View more "
                                                    aria-label="View more"
                                                  >
                                                    <Fab
                                                      color="primary"
                                                      size="small"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faAngleDown}
                                                        size="1x"
                                                      />
                                                    </Fab>
                                                  </Tooltip>
                                                </div>
                                              </Link>
                                            </Col>
                                          </Row>
                                        )}
                                      </CardBody>
                                    </Card>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          ))}

                          {this.state.myquizlist.map((itemn) => (
                            <>
                              {itemn.quizid !== null || itemn.quizid !== "" ? (
                                <>
                                  <div class="coursecat1">
                                    <Card
                                      style={{
                                        width: "100%",
                                        //border: "1px solid #232",
                                        padding: "5px",
                                        height: "auto",
                                        boxShadow: "rgb(162, 163, 159)",
                                      }}
                                    >
                                      <CardBody>
                                        <Row>
                                          <Col sm={12}>
                                            <p>
                                              <FontAwesomeIcon
                                                icon={faPaperPlane}
                                              />
                                              <br />
                                              Quiz : &nbsp;&nbsp; {itemn.title}
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col sm={6}>
                                            <p>
                                              {" "}
                                              <FontAwesomeIcon
                                                icon={faCalendarAlt}
                                              />
                                              &nbsp;
                                              {itemn.startdate}
                                            </p>
                                          </Col>
                                          <Col sm={6}>
                                            {" "}
                                            <FontAwesomeIcon icon={faClock} />
                                            &nbsp;
                                            {itemn.starttime} - {itemn.endtime}
                                          </Col>
                                        </Row>
                                        <br />

                                        {this.state.viewmoreComponent ===
                                          true &&
                                        this.state.viewmoreid ===
                                          itemn.quizid ? (
                                          <>
                                            <Row>
                                              <Col sm={12}>
                                                <Link
                                                  onClick={(e) =>
                                                    this.viewless(
                                                      e,
                                                      itemn.quizid
                                                    )
                                                  }
                                                >
                                                  <div
                                                    style={{
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <Tooltip
                                                      title="View Less "
                                                      aria-label="View Less"
                                                    >
                                                      <Fab
                                                        color="inherit"
                                                        size="small"
                                                      >
                                                        <FontAwesomeIcon
                                                          size="1x"
                                                          icon={faAngleUp}
                                                        />
                                                      </Fab>
                                                    </Tooltip>
                                                  </div>
                                                </Link>

                                                <p>
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html: itemn.description,
                                                    }}
                                                  />
                                                </p>
                                              </Col>
                                            </Row>
                                          </>
                                        ) : (
                                          <Row>
                                            <Col sm={12}>
                                              <Link
                                                onClick={(e) =>
                                                  this.viewmore(e, itemn.quizid)
                                                }
                                              >
                                                <div
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <Tooltip
                                                    title="View more "
                                                    aria-label="View more"
                                                  >
                                                    <Fab
                                                      color="primary"
                                                      size="small"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faAngleDown}
                                                        size="1x"
                                                      />
                                                    </Fab>
                                                  </Tooltip>
                                                </div>
                                              </Link>
                                            </Col>
                                          </Row>
                                        )}
                                      </CardBody>
                                    </Card>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          ))}
                        </span>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>
      </div>
    );
  }
}

export default Announcement;
